// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Surge pay (GRAVY-10443) — styles for the Rates tab editor, Manage surge pay,
 * the override and confirmation dialogs, the job banner and the toast.
 *
 * Values are transcribed from the Figma frames (40551:178777, 38664:8957,
 * 38500:97200, 38478:34438, 38482:34911, 40551:177889, 40563:187694), using
 * the same GravyWork 2.0 tokens Dashboard V2 declares. Every class is
 * \`paysurge-\` prefixed because these components render inside pages with their
 * own legacy styles.
 */

:root {
  --paysurge-green: #44a735;
  --paysurge-text-green: #2e8722;
  --paysurge-red: #cf040c;
  --paysurge-yellow: #eca300;
  --paysurge-text-yellow: #bb8700;
  --paysurge-hl-yellow: #fff4d8;
  --paysurge-stroke-yellow: #ffcc7f;
  --paysurge-black: #1c1c1c;
  --paysurge-subtext: #5b5b5b;
  --paysurge-deactivated: #979797;
  --paysurge-stroke: #dadada;
  --paysurge-surface: #fcfcfc;
  --paysurge-hl-gray: #eaeaea;
}

.paysurge-editor,
.paysurge-dialog,
.paysurge-banner,
.paysurge-toast {
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--paysurge-black);
  box-sizing: border-box;
}
.paysurge-editor *,
.paysurge-dialog *,
.paysurge-banner *,
.paysurge-toast * {
  box-sizing: border-box;
}

/* ── Editor ─────────────────────────────────────────────────────────── */

.paysurge-editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.paysurge-switchrow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 64px;
}
.paysurge-switchtext {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.paysurge-title {
  font-weight: 600;
}
.paysurge-help {
  color: var(--paysurge-subtext);
}

/* Toggle-Switch/Web: 44×24, green when on. */
.paysurge-switch {
  position: relative;
  flex: 0 0 auto;
  width: 44px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--paysurge-stroke);
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.paysurge-switch::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: transform 0.15s ease;
}
.paysurge-switch[aria-checked='true'] {
  background: var(--paysurge-green);
}
.paysurge-switch.is-pause[aria-checked='true'] {
  background: var(--paysurge-yellow);
}
.paysurge-switch[aria-checked='true']::after {
  transform: translateX(20px);
}
.paysurge-switch:disabled {
  cursor: default;
  opacity: 0.6;
}

.paysurge-tiers {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid var(--paysurge-stroke);
  border-radius: 8px;
  background: var(--paysurge-surface);
}
/* Surge off: the schedule is kept but reads as inactive (40551:178016). */
.paysurge-tiers.is-locked {
  opacity: 0.4;
}
.paysurge-tier {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
/* The 52px on the right is the trash column, reserved on every row so the
   first row's fields line up with the rows that have one. */
.paysurge-tierrow {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-right: 52px;
}
.paysurge-field {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.paysurge-label {
  font-weight: 600;
}
.paysurge-control {
  position: relative;
  display: flex;
  align-items: center;
  height: 36px;
  border: 1px solid var(--paysurge-stroke);
  border-radius: 8px;
  background: #fff;
}
.paysurge-control.has-error {
  border-color: var(--paysurge-red);
}
.paysurge-control select {
  width: 100%;
  height: 100%;
  padding: 0 40px 0 16px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font: inherit;
  color: inherit;
  appearance: none;
  cursor: pointer;
}
.paysurge-control.is-select svg {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  pointer-events: none;
}
.paysurge-control.is-money {
  gap: 12px;
  padding: 0 16px 0 12px;
}
.paysurge-control.is-money svg {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  color: var(--paysurge-green);
}
.paysurge-control.is-money.has-error svg {
  color: var(--paysurge-red);
}
.paysurge-control input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  outline: none;
}
.paysurge-suffix {
  flex: 0 0 auto;
  color: var(--paysurge-deactivated);
}
.paysurge-remove {
  position: absolute;
  right: 0;
  bottom: 6px;
  display: inline-flex;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--paysurge-red);
  cursor: pointer;
}
.paysurge-remove svg {
  width: 24px;
  height: 24px;
}
.paysurge-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--paysurge-red);
}
.paysurge-error svg {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
}
.paysurge-add {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 600;
  color: var(--paysurge-text-green);
  cursor: pointer;
}
.paysurge-add svg {
  width: 20px;
  height: 20px;
  color: var(--paysurge-green);
}
.paysurge-note,
.paysurge-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  color: var(--paysurge-subtext);
}
.paysurge-note svg,
.paysurge-info svg {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
}

/* GRAVY-10860 — the note under a tier whose moment has passed. Sits where that
   row's error would, so the row is never both locked and silent about it. */
.paysurge-note.is-tiernote {
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.paysurge-note.is-tiernote svg {
  width: 16px;
  height: 16px;
}

/* ── Dialogs ────────────────────────────────────────────────────────── */

/*
 * TOP OF THE APP'S STACK — above every surface these dialogs can open from.
 * \`src/styles/index.ts\` sets the ladder they have to clear:
 *
 *   zIndices.overlay          10000   design system modal overlay
 *   .MuiDialog-root           15000   !important, every MUI dialog
 *   .MuiPopper-root           15001   !important, poppers inside those dialogs
 *
 * The surge dialogs open from INSIDE those surfaces — the client Account
 * Settings modal (Rates tab), and the MUI "Staff Workers" staffing dialog,
 * which is where "Confirm how you found this worker" is asked. Anything below
 * the host's value renders behind it, and the failure is silent: the panel is
 * painted but covered, so clicks land on the host instead. At 10100 the
 * sourced-from prompt was invisible under the staffing dialog and the hire
 * waited forever on an answer nobody could give (GRAVY-10865); before that, at
 * 3200, "Continue & save" could not be pressed inside Account Settings.
 *
 * It looks fine in a screenshot and fails only on interaction, which is how
 * both of those survived review.
 */
.paysurge-overlay {
  position: fixed;
  inset: 0;
  z-index: 16000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(28, 28, 28, 0.6);
}
.paysurge-dialog {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-height: calc(100vh - 32px);
  overflow: auto;
  padding: 16px 20px 20px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  outline: none;
}
.paysurge-dialog.is-md {
  max-width: 600px;
}
.paysurge-dialog.is-sm {
  max-width: 560px;
  gap: 16px;
}
.paysurge-dialoghead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-top: 8px;
}
.paysurge-dialogtitle {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
}
.paysurge-dialogsub,
.paysurge-body {
  margin: 0;
  color: var(--paysurge-black);
}
.paysurge-dialogsub {
  max-width: 420px;
}
.paysurge-body {
  font-size: 16px;
}
.paysurge-close {
  display: inline-flex;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--paysurge-black);
  cursor: pointer;
}
.paysurge-close svg {
  width: 24px;
  height: 24px;
}
.paysurge-stack {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.paysurge-readonly,
.paysurge-input {
  height: 36px;
  padding: 0 16px;
  border: 1px solid var(--paysurge-stroke);
  border-radius: 8px;
  font: inherit;
  color: var(--paysurge-black);
}
.paysurge-readonly {
  border-color: transparent;
  background: #f7f7f7;
}
.paysurge-input.has-error {
  border-color: var(--paysurge-red);
}
.paysurge-fielderror,
.paysurge-formerror {
  margin: 0;
  color: var(--paysurge-red);
}
.paysurge-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.paysurge-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 36px;
  padding: 8px 16px;
  border-radius: 8px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.paysurge-btn.is-primary {
  border: 1px solid var(--paysurge-green);
  background: var(--paysurge-green);
  color: #fff;
}
.paysurge-btn.is-outline {
  border: 1px solid var(--paysurge-green);
  background: #fff;
  color: var(--paysurge-text-green);
}
.paysurge-btn.is-wide {
  min-width: 120px;
}
.paysurge-btn:disabled {
  cursor: default;
  opacity: 0.5;
}

/* ── Job banner ─────────────────────────────────────────────────────── */

.paysurge-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 24px;
  width: 100%;
  margin: 16px 0;
  padding: 12px 24px;
  border: 1px solid var(--paysurge-stroke);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
.paysurge-banner.is-paused {
  border-color: var(--paysurge-stroke-yellow);
  background: var(--paysurge-hl-yellow);
}
/*
 * The sentence takes the room and wraps inside itself, so a long one (the
 * no-tier-left state, GRAVY-10879) does not push the controls onto a line of
 * their own. Below 320px of text it still yields and the controls wrap — see
 * \`.paysurge-bannercontrols\` for where they go then.
 */
.paysurge-bannertext {
  display: flex;
  flex: 1 1 320px;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  margin: 0;
  color: var(--paysurge-black);
}
.paysurge-banner.is-paused .paysurge-bannertext {
  color: var(--paysurge-subtext);
}
.paysurge-bannertext svg {
  width: 20px;
  height: 20px;
  color: var(--paysurge-yellow);
}
.paysurge-banner.is-paused .paysurge-bannertext svg {
  color: var(--paysurge-subtext);
}
.paysurge-bannertext strong {
  font-weight: 600;
}
.paysurge-bannertext strong.is-warning {
  color: var(--paysurge-text-yellow);
}
.paysurge-bannertext strong.is-paused {
  color: var(--paysurge-black);
}
.paysurge-bannertext b {
  font-weight: 700;
}
/*
 * Always at the right edge, wrapped or not. \`space-between\` puts a lone item on
 * a wrapped line at the START, and the ⋮ menu opens leftwards from its button
 * (\`right: 0\`) — so a wrapped banner sent the menu out past the banner's left
 * edge, under the sidebar, with Override amount unclickable (GRAVY-10879).
 */
.paysurge-bannercontrols {
  display: flex;
  flex: none;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.paysurge-bannererror {
  flex-basis: 100%;
  margin: 0;
  color: var(--paysurge-red);
}
.paysurge-menuwrap {
  position: relative;
}
.paysurge-iconbtn {
  display: inline-flex;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--paysurge-black);
  cursor: pointer;
}
.paysurge-iconbtn svg {
  width: 24px;
  height: 24px;
}
.paysurge-menu {
  position: absolute;
  right: 0;
  bottom: calc(100% + 4px);
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 184px;
  padding: 8px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.paysurge-menuitem {
  padding: 8px 24px;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  color: var(--paysurge-black);
  white-space: nowrap;
  cursor: pointer;
}
.paysurge-menuitem:hover {
  background: var(--paysurge-hl-gray);
}

/* ── Toast ──────────────────────────────────────────────────────────── */

.paysurge-toast {
  position: fixed;
  top: 28px;
  right: 24px;
  /* One above the dialog overlay — it confirms a save made in one. */
  z-index: 10200;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: min(420px, calc(100vw - 48px));
  padding: 12px 24px 12px 16px;
  border: 1px solid var(--paysurge-stroke);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}
.paysurge-toasticon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  color: var(--paysurge-green);
}
.paysurge-toasticon.is-off,
.paysurge-toasticon.is-paused {
  color: var(--paysurge-subtext);
}
.paysurge-toasttext {
  display: flex;
  flex-direction: column;
}
.paysurge-toasttitle {
  font-weight: 600;
}
.paysurge-toastmessage {
  color: var(--paysurge-subtext);
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/PaySurge/paySurge.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;;EAIE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;;;EAIE,sBAAsB;AACxB;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;AACrC;AACA,0EAA0E;AAC1E;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;4DAC4D;AAC5D;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,8BAA8B;AAChC;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;4EAC4E;AAC5E;EACE,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0EAA0E;;AAE1E;;;;;;;;;;;;;;;;;;;EAmBE;AACF;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;AACA;;;;;EAKE;AACF;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;;;;;EAKE;AACF;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;;AAEA,0EAA0E;;AAE1E;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mEAAmE;EACnE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC","sourcesContent":["/*\n * Surge pay (GRAVY-10443) — styles for the Rates tab editor, Manage surge pay,\n * the override and confirmation dialogs, the job banner and the toast.\n *\n * Values are transcribed from the Figma frames (40551:178777, 38664:8957,\n * 38500:97200, 38478:34438, 38482:34911, 40551:177889, 40563:187694), using\n * the same GravyWork 2.0 tokens Dashboard V2 declares. Every class is\n * `paysurge-` prefixed because these components render inside pages with their\n * own legacy styles.\n */\n\n:root {\n  --paysurge-green: #44a735;\n  --paysurge-text-green: #2e8722;\n  --paysurge-red: #cf040c;\n  --paysurge-yellow: #eca300;\n  --paysurge-text-yellow: #bb8700;\n  --paysurge-hl-yellow: #fff4d8;\n  --paysurge-stroke-yellow: #ffcc7f;\n  --paysurge-black: #1c1c1c;\n  --paysurge-subtext: #5b5b5b;\n  --paysurge-deactivated: #979797;\n  --paysurge-stroke: #dadada;\n  --paysurge-surface: #fcfcfc;\n  --paysurge-hl-gray: #eaeaea;\n}\n\n.paysurge-editor,\n.paysurge-dialog,\n.paysurge-banner,\n.paysurge-toast {\n  font-family: 'Manrope', sans-serif;\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: 0;\n  color: var(--paysurge-black);\n  box-sizing: border-box;\n}\n.paysurge-editor *,\n.paysurge-dialog *,\n.paysurge-banner *,\n.paysurge-toast * {\n  box-sizing: border-box;\n}\n\n/* ── Editor ─────────────────────────────────────────────────────────── */\n\n.paysurge-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n.paysurge-switchrow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 64px;\n}\n.paysurge-switchtext {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.paysurge-title {\n  font-weight: 600;\n}\n.paysurge-help {\n  color: var(--paysurge-subtext);\n}\n\n/* Toggle-Switch/Web: 44×24, green when on. */\n.paysurge-switch {\n  position: relative;\n  flex: 0 0 auto;\n  width: 44px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  border-radius: 12px;\n  background: var(--paysurge-stroke);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n.paysurge-switch::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  transition: transform 0.15s ease;\n}\n.paysurge-switch[aria-checked='true'] {\n  background: var(--paysurge-green);\n}\n.paysurge-switch.is-pause[aria-checked='true'] {\n  background: var(--paysurge-yellow);\n}\n.paysurge-switch[aria-checked='true']::after {\n  transform: translateX(20px);\n}\n.paysurge-switch:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.paysurge-tiers {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  border: 1px solid var(--paysurge-stroke);\n  border-radius: 8px;\n  background: var(--paysurge-surface);\n}\n/* Surge off: the schedule is kept but reads as inactive (40551:178016). */\n.paysurge-tiers.is-locked {\n  opacity: 0.4;\n}\n.paysurge-tier {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n/* The 52px on the right is the trash column, reserved on every row so the\n   first row's fields line up with the rows that have one. */\n.paysurge-tierrow {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-right: 52px;\n}\n.paysurge-field {\n  display: flex;\n  flex: 1 1 0;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.paysurge-label {\n  font-weight: 600;\n}\n.paysurge-control {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 36px;\n  border: 1px solid var(--paysurge-stroke);\n  border-radius: 8px;\n  background: #fff;\n}\n.paysurge-control.has-error {\n  border-color: var(--paysurge-red);\n}\n.paysurge-control select {\n  width: 100%;\n  height: 100%;\n  padding: 0 40px 0 16px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n  appearance: none;\n  cursor: pointer;\n}\n.paysurge-control.is-select svg {\n  position: absolute;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n}\n.paysurge-control.is-money {\n  gap: 12px;\n  padding: 0 16px 0 12px;\n}\n.paysurge-control.is-money svg {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  color: var(--paysurge-green);\n}\n.paysurge-control.is-money.has-error svg {\n  color: var(--paysurge-red);\n}\n.paysurge-control input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n  outline: none;\n}\n.paysurge-suffix {\n  flex: 0 0 auto;\n  color: var(--paysurge-deactivated);\n}\n.paysurge-remove {\n  position: absolute;\n  right: 0;\n  bottom: 6px;\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--paysurge-red);\n  cursor: pointer;\n}\n.paysurge-remove svg {\n  width: 24px;\n  height: 24px;\n}\n.paysurge-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: var(--paysurge-red);\n}\n.paysurge-error svg {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n}\n.paysurge-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  align-self: flex-start;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-weight: 600;\n  color: var(--paysurge-text-green);\n  cursor: pointer;\n}\n.paysurge-add svg {\n  width: 20px;\n  height: 20px;\n  color: var(--paysurge-green);\n}\n.paysurge-note,\n.paysurge-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0;\n  color: var(--paysurge-subtext);\n}\n.paysurge-note svg,\n.paysurge-info svg {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n}\n\n/* GRAVY-10860 — the note under a tier whose moment has passed. Sits where that\n   row's error would, so the row is never both locked and silent about it. */\n.paysurge-note.is-tiernote {\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n}\n.paysurge-note.is-tiernote svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ── Dialogs ────────────────────────────────────────────────────────── */\n\n/*\n * TOP OF THE APP'S STACK — above every surface these dialogs can open from.\n * `src/styles/index.ts` sets the ladder they have to clear:\n *\n *   zIndices.overlay          10000   design system modal overlay\n *   .MuiDialog-root           15000   !important, every MUI dialog\n *   .MuiPopper-root           15001   !important, poppers inside those dialogs\n *\n * The surge dialogs open from INSIDE those surfaces — the client Account\n * Settings modal (Rates tab), and the MUI \"Staff Workers\" staffing dialog,\n * which is where \"Confirm how you found this worker\" is asked. Anything below\n * the host's value renders behind it, and the failure is silent: the panel is\n * painted but covered, so clicks land on the host instead. At 10100 the\n * sourced-from prompt was invisible under the staffing dialog and the hire\n * waited forever on an answer nobody could give (GRAVY-10865); before that, at\n * 3200, \"Continue & save\" could not be pressed inside Account Settings.\n *\n * It looks fine in a screenshot and fails only on interaction, which is how\n * both of those survived review.\n */\n.paysurge-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 16000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(28, 28, 28, 0.6);\n}\n.paysurge-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  padding: 16px 20px 20px;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n  outline: none;\n}\n.paysurge-dialog.is-md {\n  max-width: 600px;\n}\n.paysurge-dialog.is-sm {\n  max-width: 560px;\n  gap: 16px;\n}\n.paysurge-dialoghead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-top: 8px;\n}\n.paysurge-dialogtitle {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.paysurge-dialogsub,\n.paysurge-body {\n  margin: 0;\n  color: var(--paysurge-black);\n}\n.paysurge-dialogsub {\n  max-width: 420px;\n}\n.paysurge-body {\n  font-size: 16px;\n}\n.paysurge-close {\n  display: inline-flex;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--paysurge-black);\n  cursor: pointer;\n}\n.paysurge-close svg {\n  width: 24px;\n  height: 24px;\n}\n.paysurge-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.paysurge-readonly,\n.paysurge-input {\n  height: 36px;\n  padding: 0 16px;\n  border: 1px solid var(--paysurge-stroke);\n  border-radius: 8px;\n  font: inherit;\n  color: var(--paysurge-black);\n}\n.paysurge-readonly {\n  border-color: transparent;\n  background: #f7f7f7;\n}\n.paysurge-input.has-error {\n  border-color: var(--paysurge-red);\n}\n.paysurge-fielderror,\n.paysurge-formerror {\n  margin: 0;\n  color: var(--paysurge-red);\n}\n.paysurge-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.paysurge-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n  height: 36px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n.paysurge-btn.is-primary {\n  border: 1px solid var(--paysurge-green);\n  background: var(--paysurge-green);\n  color: #fff;\n}\n.paysurge-btn.is-outline {\n  border: 1px solid var(--paysurge-green);\n  background: #fff;\n  color: var(--paysurge-text-green);\n}\n.paysurge-btn.is-wide {\n  min-width: 120px;\n}\n.paysurge-btn:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n/* ── Job banner ─────────────────────────────────────────────────────── */\n\n.paysurge-banner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 24px;\n  width: 100%;\n  margin: 16px 0;\n  padding: 12px 24px;\n  border: 1px solid var(--paysurge-stroke);\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n.paysurge-banner.is-paused {\n  border-color: var(--paysurge-stroke-yellow);\n  background: var(--paysurge-hl-yellow);\n}\n/*\n * The sentence takes the room and wraps inside itself, so a long one (the\n * no-tier-left state, GRAVY-10879) does not push the controls onto a line of\n * their own. Below 320px of text it still yields and the controls wrap — see\n * `.paysurge-bannercontrols` for where they go then.\n */\n.paysurge-bannertext {\n  display: flex;\n  flex: 1 1 320px;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  margin: 0;\n  color: var(--paysurge-black);\n}\n.paysurge-banner.is-paused .paysurge-bannertext {\n  color: var(--paysurge-subtext);\n}\n.paysurge-bannertext svg {\n  width: 20px;\n  height: 20px;\n  color: var(--paysurge-yellow);\n}\n.paysurge-banner.is-paused .paysurge-bannertext svg {\n  color: var(--paysurge-subtext);\n}\n.paysurge-bannertext strong {\n  font-weight: 600;\n}\n.paysurge-bannertext strong.is-warning {\n  color: var(--paysurge-text-yellow);\n}\n.paysurge-bannertext strong.is-paused {\n  color: var(--paysurge-black);\n}\n.paysurge-bannertext b {\n  font-weight: 700;\n}\n/*\n * Always at the right edge, wrapped or not. `space-between` puts a lone item on\n * a wrapped line at the START, and the ⋮ menu opens leftwards from its button\n * (`right: 0`) — so a wrapped banner sent the menu out past the banner's left\n * edge, under the sidebar, with Override amount unclickable (GRAVY-10879).\n */\n.paysurge-bannercontrols {\n  display: flex;\n  flex: none;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.paysurge-bannererror {\n  flex-basis: 100%;\n  margin: 0;\n  color: var(--paysurge-red);\n}\n.paysurge-menuwrap {\n  position: relative;\n}\n.paysurge-iconbtn {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--paysurge-black);\n  cursor: pointer;\n}\n.paysurge-iconbtn svg {\n  width: 24px;\n  height: 24px;\n}\n.paysurge-menu {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 4px);\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  min-width: 184px;\n  padding: 8px 0;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n.paysurge-menuitem {\n  padding: 8px 24px;\n  border: 0;\n  background: none;\n  font: inherit;\n  text-align: left;\n  color: var(--paysurge-black);\n  white-space: nowrap;\n  cursor: pointer;\n}\n.paysurge-menuitem:hover {\n  background: var(--paysurge-hl-gray);\n}\n\n/* ── Toast ──────────────────────────────────────────────────────────── */\n\n.paysurge-toast {\n  position: fixed;\n  top: 28px;\n  right: 24px;\n  /* One above the dialog overlay — it confirms a save made in one. */\n  z-index: 10200;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  max-width: min(420px, calc(100vw - 48px));\n  padding: 12px 24px 12px 16px;\n  border: 1px solid var(--paysurge-stroke);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n.paysurge-toasticon {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  color: var(--paysurge-green);\n}\n.paysurge-toasticon.is-off,\n.paysurge-toasticon.is-paused {\n  color: var(--paysurge-subtext);\n}\n.paysurge-toasttext {\n  display: flex;\n  flex-direction: column;\n}\n.paysurge-toasttitle {\n  font-weight: 600;\n}\n.paysurge-toastmessage {\n  color: var(--paysurge-subtext);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
